import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateRoute = (props) => {

    const isAuth = true;

    return isAuth
        ? (<Route path={props.path} exact={props.exact} component={props.component} />)
        : (<Redirect to={`${process.env.REACT_APP_WEBSITE_NAME}/auth`} />);
};
export default PrivateRoute;